<template>
    <SurveyComponent v-if="surveyModel" :model="surveyModel" />
</template>

<script setup>
import { onMounted, shallowRef } from 'vue';
import { Model } from 'survey-core';
import 'survey-core/survey-core.css';
import 'survey-core/i18n/polish';
import 'survey-core/i18n/german';
import 'survey-core/i18n/french';
import 'survey-core/i18n/spanish';
import { SurveyComponent } from 'survey-vue3-ui';

const props = defineProps({
  survey: {
    type: Object,
    required: true,
  },
  uploadUrl: {
    type: String,
    default: '',
  },
  downloadUrl: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['completed']);

const surveyModel = shallowRef(null);

onMounted(() => {
  const model = new Model(props.survey.schema);
  if (!model.locale) {
    model.locale = 'pl';
  }

  if (props.survey.theme) {
    model.applyTheme(props.survey.theme);
  }

  model.onComplete.add((sender) => {
    emit('completed', sender.data);
  });

  if (props.uploadUrl) {
    model.onUploadFiles.add((_, options) => {
      const formData = new FormData();
      options.files.forEach((file) => {
          console.log(file);
        formData.append('files[]', file, file.name);
      });

      fetch(props.uploadUrl, {
        method: 'POST',
        body: formData,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`Upload failed: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          options.callback(
            'success',
            options.files.map((file) => ({
              file: file,
              content: data[file.name],
            })),
          );
        })
        .catch((error) => {
            console.error(error);
          options.callback('error');
        });
    });
  }

  surveyModel.value = model;
});
</script>
